import { render, staticRenderFns } from "./class-report.vue?vue&type=template&id=fbae6a4a&scoped=true"
import script from "./class-report.vue?vue&type=script&lang=js"
export * from "./class-report.vue?vue&type=script&lang=js"
import style0 from "./class-report.vue?vue&type=style&index=0&id=fbae6a4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbae6a4a",
  null
  
)

export default component.exports